import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class MismatchedWBSError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService, additionalData) {
    super(reportService, 'One or WBS codes in data file do not align with imported WBS plan', 'WBS_MISMATCH_ERROR', 0, true, additionalData);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/MismatchedWBSError.ts